/* eslint-disable react/jsx-props-no-spreading */
import {
  ClinicalCarePriorityPicker,
  Filter, Form, ListManager, PageHeader, Paginator, Styles,
} from '@/components'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import usePageTitle from '@/hooks/usePageTitle'
import useQuery from '@/hooks/useQuery'
import clinicalCares from '@/services/api/clinicalCares'
import React, { useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import Row from '../components/Row'
import ClinicalCaresQuickFilter from '../components/QuickFilter'
import mapTitles from './mapTitles'

function Status({ title }) {
  usePageTitle({ title })
  const query = useQuery()
  const params = useParams()
  const [filteredPriority, setFilteredPriority] = useState()
  const [changingPriority, setChangingPriority] = useState(false)

  const {
    loading, data, error,
  } = useAxiosRequest(clinicalCares.list, { status: params?.status, ...query })

  const titleParams = mapTitles(params?.status)
  const canAddClinicalCare = params?.status === 'all'

  return (
    <Styles.Container className="grid-xl">
      <PageHeader
        title={titleParams.title}
        icon={titleParams.icon}
        subtitle={titleParams.subtitle}
        rightAction={() => (
          <>
            <Filter
              initialValues={{
                'animal.categoryId_eq': '',
                'animal.gender_eq': '',
                'animal.name_cont': '',
                'clinic.fullName_cont': '',
                'priority.id_eq': '',
                protocolNumber_eq: '',
                createdAt_between: [],
                scheduledTo_between: [],
              }}
              onClear={() => setFilteredPriority(undefined)}
              title="Filtrar atendimentos"
              renderForm={({ values, setFieldValue }) => (
                <>
                  <div className="divider text-center" data-content="Períodos" />
                  <Form.Group>
                    <Form.Label className="text-small" htmlFor="createdAtBetween">Solicitadas de - até</Form.Label>
                    <Form.DatePickerField
                      placeholderText="Data início - Data fim"
                      dateFormat="dd/MM/yyyy"
                      startDate={
                        values.createdAt_between[0] ? new Date(values.createdAt_between[0]) : null
                      }
                      endDate={
                        values.createdAt_between[1] ? new Date(values.createdAt_between[1]) : null
                      }
                      selectsEnd
                      className="form-input input-sm"
                      selectsRange
                      isClearable
                      name="createdAt_between"
                      onChange={(v) => {
                        const [start, end] = v || []
                        if (!start && !end) setFieldValue('createdAt_between', [])
                        const formattedValues = []
                        if (start) formattedValues.push(start)
                        if (end) formattedValues.push(new Date(end.setUTCHours(23, 59, 59, 999)))

                        setFieldValue('createdAt_between', formattedValues)
                      }}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label className="text-small" htmlFor="scheduledToBetween">Agendado de - até</Form.Label>
                    <Form.DatePickerField
                      placeholderText="Data início - Data fim"
                      dateFormat="dd/MM/yyyy"
                      startDate={
                        values.scheduledTo_between[0]
                          ? new Date(values.scheduledTo_between[0]) : null
                      }
                      endDate={
                        values.scheduledTo_between[1]
                          ? new Date(values.scheduledTo_between[1]) : null
                      }
                      selectsEnd
                      className="form-input input-sm"
                      selectsRange
                      isClearable
                      name="scheduledTo_between"
                      onChange={(v) => {
                        const [start, end] = v || []
                        if (!start && !end) setFieldValue('scheduledTo_between', [])
                        const formattedValues = []
                        if (start) formattedValues.push(start)
                        if (end) formattedValues.push(new Date(end.setUTCHours(23, 59, 59, 999)))

                        setFieldValue('scheduledTo_between', formattedValues)
                      }}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label className="text-small" htmlFor="['priority.id_eq']">Prioridade</Form.Label>
                    <Form.ValidationField name="['priority.id_eq']">
                      {({ field }) => (
                        <div className="d-flex align-center">
                          <span
                            style={{
                              backgroundColor: filteredPriority ? filteredPriority.color : '#f4f4f4',
                              color: filteredPriority ? '#fff' : 'inherit',
                              borderRadius: 5,
                              padding: '2px 5px',
                              fontWeight: 'bold',
                              fontSize: 12,
                            }}
                          >
                            {filteredPriority ? filteredPriority.title : 'Todas as prioridades'}
                            {filteredPriority && (
                              <a
                                className="text-light py-2 pl-2 c-hand"
                                onClick={() => {
                                  setFieldValue(field.name, '')
                                  setFilteredPriority(undefined)
                                }}
                              >
                                <i className="fas fa-times" />
                              </a>
                            )}
                          </span>
                          <a
                            className="btn btn-sm btn-action btn-link tooltip tooltip-right"
                            data-tooltip="Alterar prioridade"
                            onClick={() => setChangingPriority(true)}
                          >
                            <i className="fas fa-edit" />
                          </a>

                          <ClinicalCarePriorityPicker
                            active={changingPriority}
                            selected={filteredPriority}
                            onClose={() => setChangingPriority(false)}
                            onSelect={(priority) => {
                              setFieldValue(field.name, priority.id)
                              setFilteredPriority(priority)
                              setChangingPriority(false)
                            }}
                          />
                        </div>
                      )}
                    </Form.ValidationField>
                  </Form.Group>
                  <Form.Group>
                    <Form.Label className="label-sm pt-2" htmlFor="protocolNumber_eq">Protocolo</Form.Label>
                    <Form.ValidationField
                      name="protocolNumber_eq"
                      className="input-sm"
                      id="protocolNumber_eq"
                      autoComplete="none"
                      placeholder="Nº do protocolo"
                    />
                  </Form.Group>
                  <div className="divider text-center" data-content="Animal" />
                  <Form.Group>
                    <Form.Label className="label-sm pt-2" htmlFor="animal.name_cont">Nome do pet</Form.Label>
                    <Form.ValidationField
                      name="['animal.name_cont']"
                      className="input-sm"
                      id="animal.name_cont"
                      autoComplete="none"
                      placeholder="Totó da Silva"
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label className="text-small" htmlFor="animal.categoryId_eq">Espécie do pet</Form.Label>
                    <Form.ValidationField name="['animal.categoryId_eq']">
                      {
                        ({ field }) => (
                          <Form.Select
                            {...field}
                            id="animal.categoryId_eq"
                            className="select-sm"
                            placeholder="Espécie do pet"
                          >
                            <option value="">Todos</option>
                            <option value="1">Cachorro</option>
                            <option value="2">Gato</option>
                          </Form.Select>
                        )
                      }
                    </Form.ValidationField>
                  </Form.Group>
                  <Form.Group>
                    <Form.Label className="text-small" htmlFor="animal.gender_eq">Gênero do pet</Form.Label>
                    <Form.ValidationField name="['animal.gender_eq']">
                      {
                        ({ field }) => (
                          <Form.Select
                            {...field}
                            id="animal.gender_eq"
                            className="select-sm"
                            placeholder="Gênero do pet"
                          >
                            <option value="">Todos</option>
                            <option value="male">Macho</option>
                            <option value="female">Fêmea</option>
                          </Form.Select>
                        )
                      }
                    </Form.ValidationField>
                  </Form.Group>
                  <div className="divider text-center" data-content="Clínica" />
                  <Form.Group>
                    <Form.Label className="label-sm pt-2" htmlFor="['clinic.fullName_cont']">Nome da clínica</Form.Label>
                    <Form.ValidationField
                      name="['clinic.fullName_cont']"
                      className="input-sm"
                      id="['clinic.fullName_cont']"
                      autoComplete="none"
                      placeholder="Nome da clínica"
                    />
                  </Form.Group>
                </>
              )}
            />
            {
              canAddClinicalCare && (
                <Link to="/app/clinical-cares/form/add" className="btn btn-primary">
                  <i className="fas fa-plus" />
                  &nbsp;Adicionar
                </Link>
              )
            }
          </>
        )}
      />
      <ClinicalCaresQuickFilter />
      <ListManager loading={loading} count={data?.count || 0} error={error}>
        {
          Boolean(data) && (
            <div>
              <small>
                <table className="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th>Solicitante</th>
                      <th>Pet</th>
                      <th>Clínica</th>
                      <th width="100px">Status</th>
                      <th width="200px">Prioridade</th>
                      <th width="150px">Solicitado em</th>
                      <th width="100px">Agendado para</th>
                      <th width="100px" className="text-right">Valor atual</th>
                      <th width="1">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      data.rows.map((clinicalCare) => (
                        <Row key={clinicalCare.id} clinicalCare={clinicalCare} />
                      ))
                    }
                  </tbody>
                </table>
              </small>
              {
                Boolean(data) && (
                  <div className="my-2">
                    <Paginator paginatedList={data} />
                  </div>
                )
              }
            </div>
          )
        }
      </ListManager>
    </Styles.Container>
  )
}

export default Status
